import featureTagsService from "@/services/featureTagsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await featureTagsService.create(formData);
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await featureTagsService.findAll();
      commit("setAllFeatureTags", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattungen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingleFeatureTag", null);
    try {
      const res = await featureTagsService.findOne({ id });
      commit("setSingleFeatureTag", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await featureTagsService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await featureTagsService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Ausstattung wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Ausstattung konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateAdminOrder({ dispatch }, formData) {
    try {
      await featureTagsService.updateAdminOrder(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Reihenfolge konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async updateWebsiteOrder({ dispatch }, formData) {
    try {
      await featureTagsService.updateWebsiteOrder(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Reihenfolge konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAllFeatureTags(state, object) {
    state.all = object;
  },
  setSingleFeatureTag(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
